import React, { useState, useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import HttpService from "../../services/httpService";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Dialog,
    DialogContent,
    FormControl,
    TextField,
    IconButton,
    DialogActions,
    Button,
    Chip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import RefreshIcon from "@material-ui/icons/Refresh";
import DeleteIcon from "@material-ui/icons/Delete";
import Tooltip from "@material-ui/core/Tooltip";
import rewardImage from "../../assets/img/org/reward.png";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME, ERPSAchievementPercentage, rolesId, COLORS } from "../../utils/index";
import { Link } from "react-router-dom";
import "../../App.css";
import ERPSDashBoard from './ERPSDashBoard';
import { MdPerson, MdEmail, MdPhone, MdConfirmationNumber, MdWork, MdFingerprint } from "react-icons/md";

const useStyles = makeStyles(() => ({
    root: {
        // width: '80vw',
        // height: '70vh',
        // margin: '0 auto',
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    },
    title: {
        fontWeight: 700,
        color: "#1e293b",
        marginBottom: "32px",
        textAlign: "center",
    },
    headerCell: {
        backgroundColor: "#F47E46",
        color: "white",
        fontWeight: "bold",
        fontSize: "18px",
        padding: "20px",
        borderRight: "1px solid rgba(255,255,255,0.2)",
        position: "sticky",
        top: 0,
        textAlign: "center",
        zIndex: 1,
    },
    tableRowEven: {
        backgroundColor: "#ffffff",
    },
    tableRowOdd: {
        backgroundColor: "#f0f4f8",
    },
    cell: {
        fontSize: "16px",
        fontWeight: "bold",
        padding: "20px",
        borderRight: "1px solid #e0e0e0",
        color: "#263238",
    },
    valueCell: {
        fontSize: "18px",
        fontWeight: "bold",
        padding: "20px",
        color: "#0d47a1",
        borderRight: "1px solid #e0e0e0",
        textAlign: "center",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: "#e3f2fd",
        },
    },
    paper: {
        textAlign: "center",
    },
    headerContainer: {
        width: "100%",
        padding: "20px",
        borderRadius: "12px",
        color: "#000000ff",
        background: "linear-gradient(135deg, #1c375d, #1c375d)",
        boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
        transition: "all 0.6s ease-in-out",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        "@media (max-width: 1200px)": {
            padding: "18px",
        },
        "@media (max-width: 960px)": {
            padding: "15px",
        },
        "@media (max-width: 600px)": {
            padding: "12px",
        },
    },
    headerImage: {
        objectFit: "contain",
        flexShrink: 0,
        position: "absolute",
        left: "20px",
        height: "130px",
        width: "145px",
        "@media (max-width: 1200px)": {
            height: "110px",
            width: "125px",
            left: "15px",
        },
        "@media (max-width: 960px)": {
            height: "90px",
            width: "105px",
            left: "10px",
        },
        "@media (max-width: 600px)": {
            height: "70px",
            width: "80px",
            left: "8px",
        },
        "@media (max-width: 400px)": {
            height: "55px",
            width: "65px",
            left: "5px",
        },
    },
    headerTitle: {
        fontWeight: 700,
        letterSpacing: "1px",
        color: "white",
        "@media (max-width: 960px)": {
            fontSize: "28px",
        },
        "@media (max-width: 600px)": {
            fontSize: "22px",
        },
        "@media (max-width: 400px)": {
            fontSize: "18px",
        },
    },
}));

const useStylesTable = makeStyles((theme) => ({
    root: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: "1px solid #eee5e5",
        background: "blue",
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: "100%",
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial",
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: "#FDB913",
        color: "#151921",
        padding: "1",
        marginRight: "0.5em",
        borderRadius: "20px",
        width: "20%",
        "&:hover": { backgroundColor: "#14419c", color: "white" },
    },
    leadClearButton: {
        backgroundColor: "#f7b7b7", // light red background
        color: "#151921",
        padding: "1",
        marginRight: "0.5em",
        borderRadius: "20px",
        width: "20%",
        // "&:hover": {
        //     backgroundColor: "#f7b7b7", // same light red on hover
        //     color: '#151921' // same text color on hover
        // }
    },
    submitButton: {
        backgroundColor: "#F47E46 !important", // Decorpot Orange
        color: "white", // White text
        "&:hover": {
            backgroundColor: "#E0663D !important", // Darker Orange on hover
        },
    },
    clearButton: {
        backgroundColor: "#FFF2EB !important", // Light Beige
        color: "#1C375D !important", // Decorpot Orange text
        "&:hover": {
            backgroundColor: "#E7BAD0 !important", // Light Pink on hover
        },
    },
    searchButton: {
        backgroundColor: "#FDB913 !important", // Bright Yellow for emphasis
        color: "#1C375D !important", // Dark Blue text for contrast
        "&:hover": {
            backgroundColor: "#E6A411 !importan", // Darker yellow on hover
        },
    },
}));

const getRandomColor = () => {
    return COLORS[Math.floor(Math.random() * COLORS.length)];
};

const ACHIEVEMENT_OPTIONS = [
    { label: "60%", value: ERPSAchievementPercentage["60%"], color: "#f44336" },
    { label: "70%", value: ERPSAchievementPercentage["70%"], color: "#ff9800" },
    { label: "80%", value: ERPSAchievementPercentage["80%"], color: "#ffc107" },
    { label: "90%", value: ERPSAchievementPercentage["90%"], color: "#8bc34a" },
    { label: "100%", value: ERPSAchievementPercentage["100%"], color: "#4caf50" },
];

const ERPSFilter = (props) => {
    const classes = useStyles();
    const classesTable = useStylesTable();
    const { userDetails } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const [commonExpCenter, setExpCenter] = useState([]);
    const [commonLocation, setLocation] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const [selectedUser, setSelectedUser] = useState([]);
    const [selectedAchievementPercentage, setSelectedAchievementPercentage] = useState("");
    const [selectedSearchType, setSelectedSearchType] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [dateFilter, setDateFilter] = useState({
        year: '',
        month: ''
    });
    const [storeDateFilter, setStoreDateFilter] = useState({ startDate: '', endDate: '' });
    // Separate date filter for My Rewards only
    const [myRewardsDateFilter, setMyRewardsDateFilter] = useState({ startDate: '', endDate: '' });
    const [rewardsData, setRewardsData] = useState([]);
    const [filteredRewardsData, setFilteredRewardsData] = useState([]);
    const searchTypes = [
        { label: 'Customer Name', value: 'Customer Name', icon: <MdPerson />, color: "#1976d2" },
        { label: 'Email ID', value: 'Email ID', icon: <MdEmail />, color: "#d32f2f" },
        { label: 'Lead No', value: 'Lead No', icon: <MdConfirmationNumber />, color: "#ed6c02" },
        { label: 'Project No', value: 'Project No', icon: <MdWork />, color: "#2e7d32" },
        { label: 'Contact No', value: 'Contact No', icon: <MdPhone />, color: "#6a1b9a" },
        { label: 'Unique Lead No', value: 'Unique Lead No', icon: <MdFingerprint />, color: "#00838f" }
    ];
    const [loading, setLoading] = useState(false);
    const [viewMode, setViewMode] = useState('myRewards');
    const SUPERIOR_ROLES = [
        'Operation Design Manager', 'Design Manager', 'Sales Manager',
        'Operation Manager', 'Design Head', 'DGM Design', 'AGM Design',
        'AGM Sales', 'DGM Ops', 'Assistant Sales Manager'
    ];
    const userRoleNames = userDetails?.roles?.map(r => r.name) || [];
    const isSuperior = SUPERIOR_ROLES.some(r => userRoleNames.includes(r));
    const isAdmin = userRoleNames.includes('Admin') || userRoleNames.includes('Data Analyst');
    const showToggle = isSuperior && !isAdmin;
    const [viewType, setViewType] = useState('team');
    const [roleFilter, setRoleFilter] = useState('');
    const [hierarchyUsers, setHierarchyUsers] = useState([]);
    const [selectedHierarchyUser, setSelectedHierarchyUser] = useState([]);
    const [availableRoles, setAvailableRoles] = useState([]);
    const [clearFilterTrigger, setClearFilterTrigger] = useState(false);
    const [roleWiseFilter, setRoleWiseFilter] = useState(''); // 'Designer', 'ODM', 'AGM'
    const [roleWiseUsers, setRoleWiseUsers] = useState([]);
    const [selectedRoleWiseUser, setSelectedRoleWiseUser] = useState([]);
    useEffect(() => {
        setFilteredRewardsData(rewardsData);
    }, [rewardsData]);


    useEffect(() => {
        handleSubmitAllFilters();
    }, [])

    useEffect(() => {
        getAllLocations();
    }, []);

    useEffect(() => {
        getAllExpCenters();
        setSelectedExperienceCenter([]);
    }, [selectedLocation]);

    // Fetch hierarchy users based on selected role
    useEffect(() => {
        const fetchHierarchyUsers = async () => {
            if (!showToggle || viewMode !== 'myTeam') return;
            try {
                const response = await HttpService.getHierarchyUsers({
                    role: roleFilter,
                    managerId: userDetails._id
                });
                if (response?.data?.success) {
                    setHierarchyUsers(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching hierarchy users:', error);
            }
        };
        fetchHierarchyUsers();
    }, [roleFilter, showToggle, viewMode]);

    // Fetch users based on role-wise filter (for DGM/Admin)
        useEffect(() => {
            const fetchRoleWiseUsers = async () => {
               
                const isDGMOrAdmin = userRoleNames.includes('DGM Ops') || userRoleNames.includes('DGM Design') || userRoleNames.includes('AGM Design') || isAdmin;
                if (!isDGMOrAdmin || !roleWiseFilter) return;
                
                try {
                    const response = await HttpService.getHierarchyUsers({
                        role: roleWiseFilter,
                        managerId: userDetails._id
                    });
                    if (response?.data?.success) {
                        setRoleWiseUsers(response.data.data);
                    }
                } catch (error) {
                    console.error('Error fetching role-wise users:', error);
                }
            };
            fetchRoleWiseUsers();
        }, [roleWiseFilter, userDetails, isAdmin]);

    // Set available roles for manager based on their hierarchy
    useEffect(() => {
        if (!showToggle || viewMode !== 'myTeam') return;

        const userRoleNames = userDetails?.roles?.map(r => r.name) || [];

        if (userRoleNames.includes('DGM Ops') || userRoleNames.includes('DGM Design')) {
            setAvailableRoles(['AGM', 'ODM', 'Designer']);
        } else if (userRoleNames.includes('AGM Design') || userRoleNames.includes('AGM Sales')) {
            setAvailableRoles(['ODM', 'Designer']);
        } else if (userRoleNames.includes('Operation Design Manager') || userRoleNames.includes('Design Manager')) {
            setAvailableRoles(['Designer']);
        }
    }, [showToggle, viewMode, userDetails]);

    const getLocationIds = (locations = []) => locations.map((location) => location._id);
    const getExperienceCenterLocationIds = (experienceCenter) =>
        Array.isArray(experienceCenter.locationId)
            ? experienceCenter.locationId.map((location) => location?._id || location)
            : [experienceCenter.locationId?._id || experienceCenter.locationId];
    const getAllLocations = async () => {
        props.setLoading(true);
        try {
            // Use the dedicated endpoint so AGM/DGM get locations from all managed
            // teams — not just their own directly-assigned locationId in the token.
            const response = await HttpService.getManagerLocations();
            if (response?.data?.success) {
                setLocation(response.data.locationId || []);
            }
        } catch (error) {
            console.error("Error fetching locations:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }
        props.setLoading(false);
    };

    const getAllExpCenters = async (locationIds = getLocationIds(selectedLocation)) => {
        props.setLoading(true);
        try {
            if (locationIds.length > 0) {
                const response = await HttpService.getExpericenCenters();
                setExpCenter(
                    response.data.filter((experienceCenter) =>
                        getExperienceCenterLocationIds(experienceCenter).some((locationId) =>
                            locationIds.includes(locationId),
                        ),
                    ),
                );
            } else {
                setExpCenter([]);
            }
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }
        props.setLoading(false);
    };

    const getERPSUsersData = async (expId) => {
        if (!expId || expId.length === 0) {
            setUsersData([]);
            return;
        }
        props.setLoading(true);
        try {
            const selectedExpCenters = expId.map((exp) => exp._id);
            const payload = {
                allExpIds: selectedExpCenters,
                designUserRoleId: rolesId.designUser,
            };
            const response = await HttpService.getERPSUsersData(payload);
            setUsersData(response?.data?.data || []);
        } catch (error) {
            console.error("Error fetching users:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }
        props.setLoading(false);
    };

    const selectedItem = ACHIEVEMENT_OPTIONS.find(
        (i) => i.value === selectedAchievementPercentage
    );

    // this is rewards Points API.
    const handleSubmitAllFilters = async (forcedViewMode) => {
        setLoading(true);
        // props.setLoading(true);
        try {
            const currentViewMode = showToggle ? (forcedViewMode || viewMode) : undefined;
        
        // Combine regular selectedUser and role-wise selected users
        let combinedSelectedUsers = [...selectedUser];
        
        // Add role-wise selected users if any
        if (selectedRoleWiseUser && selectedRoleWiseUser.length > 0) {
            selectedRoleWiseUser.forEach(user => {
                if (!combinedSelectedUsers.some(u => u._id === user._id)) {
                    combinedSelectedUsers.push(user);
                }
            });
        }
        
        let userIdsToSend = combinedSelectedUsers.map((user) => user._id);

        if (currentViewMode === 'myRewards') {
            userIdsToSend = [];
        }
            const payload = {
                // userIds: selectedUser.map((user) => user._id),
                userIds: userIdsToSend,
                experienceCenterIds: selectedExperienceCenter.map((exp) => exp._id),
                locationIds: selectedLocation.map((loc) => loc._id),
                selectedExperienceCenter: selectedExperienceCenter.map((exp) => exp.name),
                selectedLocation: selectedLocation.map((loc) => loc.name),
                month: dateFilter.month,
                year: dateFilter.year,
                achievementPercentage: selectedAchievementPercentage,
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                searchType: selectedSearchType,
                search: searchInput,
                viewMode: showToggle ? (forcedViewMode || viewMode) : undefined,
                // loginInUser: userDetails._id
            };
            const res = await HttpService.getERPSRewardsData(payload);
            if (res?.data?.success) {
                setRewardsData(res?.data?.data || []);
                setViewType(res?.data?.viewType || 'team');
            }

        } catch (err) {
            const errorMessage =
                err?.response?.data?.message ||
                "Something went wrong while fetching rewards data";

            props.setSnackInfo(errorMessage, "error");
        } finally {
            setLoading(false);
            // props.setLoading(false);
        }
    };

    const handleClearAllFilters = () => {
        setSelectedLocation([]);
        setSelectedExperienceCenter([]);
        setSelectedUser([]);
        setSelectedRoleWiseUser([]);
        setRoleWiseFilter('');
        setSelectedAchievementPercentage("");
        setSelectedSearchType('');
        setSearchInput('');
        setDateFilter({ year: '', month: '' });
        setStoreDateFilter({ startDate: '', endDate: '' });
        setMyRewardsDateFilter({ startDate: '', endDate: '' });
        setRewardsData([]);
        setExpCenter([]);
        setUsersData([]);
        setClearFilterTrigger(true);
    };

    useEffect(() => {
    if (clearFilterTrigger) {
        handleSubmitAllFilters(viewMode);
        setClearFilterTrigger(false);
    }
    }, [clearFilterTrigger, viewMode]);

    // Separate function ONLY for My Rewards date filter — does NOT affect team data
    const handleMyRewardsDateSubmit = async () => {
        setLoading(true);
        try {
            const payload = {
                userIds: [],
                experienceCenterIds: [],
                locationIds: [],
                selectedExperienceCenter: [],
                selectedLocation: [],
                month: '',
                year: '',
                achievementPercentage: '',
                startDate: myRewardsDateFilter.startDate,
                endDate: myRewardsDateFilter.endDate,
                searchType: '',
                search: '',
                viewMode: 'myRewards',
            };
            const res = await HttpService.getERPSRewardsData(payload);
            if (res?.data?.success) {
                setRewardsData(res?.data?.data || []);
                setViewType(res?.data?.viewType || 'team');
            }
        } catch (err) {
            const errorMessage =
                err?.response?.data?.message ||
                'Something went wrong while fetching rewards data';
            props.setSnackInfo(errorMessage, 'error');
        } finally {
            setLoading(false);
        }
    };

    // Conditional filter rendering logic
    const shouldShowAllFilters =
        isAdmin ||  // Designer case
        (showToggle && viewMode === 'myTeam');  // Manager + My Team case

    return (
        <div className='App'>
            {/* All Filter Start Here */}
            <div className={classes.headerContainer}>
                <img
                    src={rewardImage}
                    alt="Reward"
                    className={classes.headerImage}
                />
                <Typography
                    variant="h4"
                    className={classes.headerTitle}
                >
                    ✨ Employee Reward Points System ✨
                </Typography>
            </div>
            <br />
            <div>
                {shouldShowAllFilters && (
                <Paper
                    style={{
                        padding: "2rem",
                        borderRadius: "10px",
                        boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
                    }}>
                    {/* === Filters: Location, Exp Center, Dates === */}
                    <Grid
                        container
                        spacing={2}
                        alignItems='center'
                        style={{ marginBottom: "1rem" }}>
                        {/* {shouldShowAllFilters && (
                            <> */}
                                <Grid item xs={12} sm={3}>
                                    <FormControl fullWidth>
                                        <Autocomplete
                                            multiple
                                            value={selectedLocation}
                                            options={commonLocation}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(e, val) => {
                                                setSelectedLocation(val);
                                                setSelectedExperienceCenter([]);
                                            }}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => {
                                                    const color = getRandomColor();
                                                    return (
                                                        <Chip
                                                            {...getTagProps({ index })}
                                                            label={option.name}
                                                            style={{
                                                                backgroundColor: color,
                                                                color: "#fff",
                                                                margin: 2
                                                            }}
                                                        />
                                                    );
                                                })}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label='Select Location'
                                                    variant='outlined'
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl fullWidth>
                                        <Autocomplete
                                            multiple
                                            value={selectedExperienceCenter}
                                            options={commonExpCenter}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(e, val) => {
                                                setSelectedExperienceCenter(val);
                                                getERPSUsersData(val);
                                            }}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => {
                                                    const color = getRandomColor();
                                                    return (
                                                        <Chip
                                                            {...getTagProps({ index })}
                                                            label={option.name}
                                                            style={{
                                                                backgroundColor: color,
                                                                color: "#fff",
                                                                margin: 2
                                                            }}
                                                        />
                                                    );
                                                })}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label='Select Exp-Center'
                                                    variant='outlined'
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl fullWidth>
                                        <Autocomplete
                                            multiple
                                            value={selectedUser}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(e, val) => {
                                                setSelectedUser(val);
                                            }}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => {
                                                    const color = getRandomColor();
                                                    return (
                                                        <Chip
                                                            {...getTagProps({ index })}
                                                            label={option.name}
                                                            style={{
                                                                backgroundColor: color,
                                                                color: "#fff",
                                                                margin: 2
                                                            }}
                                                        />
                                                    );
                                                })}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label='Select Designer'
                                                    variant='outlined'
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl fullWidth>
                                        <TextField
                                            select
                                            label="Select Achievement %"
                                            variant="outlined"
                                            value={selectedAchievementPercentage}
                                            onChange={(e) => setSelectedAchievementPercentage(e.target.value)}
                                            fullWidth
                                            style={{
                                                backgroundColor: selectedItem?.color || "",
                                                borderRadius: 4
                                            }}
                                            InputProps={{
                                                style: { color: selectedItem ? "#fff" : "" }
                                            }}
                                        >
                                            <MenuItem value="">None</MenuItem>

                                            {ACHIEVEMENT_OPTIONS.map((item) => (
                                                <MenuItem key={item.value} value={item.value}>
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            width: "100%",
                                                            backgroundColor: item.color,
                                                            color: "#fff",
                                                            padding: "5px",
                                                            fontWeight: "bold",
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        {item.label}
                                                    </span>
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </FormControl>
                                </Grid>

                                {/* NEW: Role Filter - Sirf Managers ke liye */}
                                {/* {showToggle && viewMode === 'myTeam' && availableRoles.length > 0 && (
                                    <Grid item xs={12} sm={3}>
                                        <FormControl fullWidth>
                                            <TextField
                                                select
                                                label="Select Role"
                                                variant="outlined"
                                                value={roleFilter}
                                                onChange={(e) => {
                                                    setRoleFilter(e.target.value);
                                                    setSelectedHierarchyUser([]);
                                                }}
                                                fullWidth
                                            >
                                                <MenuItem value="">All Roles</MenuItem>
                                                {availableRoles.map((role) => (
                                                    <MenuItem key={role} value={role}>{role}</MenuItem>
                                                ))}
                                            </TextField>
                                        </FormControl>
                                    </Grid>
                                )} */}

                                {/* NEW: User Filter - Hierarchy based */}
                                {/* {showToggle && viewMode === 'myTeam' && hierarchyUsers.length > 0 && (
                                    <Grid item xs={12} sm={3}>
                                        <FormControl fullWidth>
                                            <Autocomplete
                                                multiple
                                                value={selectedHierarchyUser}
                                                options={hierarchyUsers}
                                                getOptionLabel={(option) => option.name}
                                                onChange={(e, val) => {
                                                    setSelectedHierarchyUser(val);
                                                    setSelectedUser(val);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label={`Select ${roleFilter || 'User'}${roleFilter ? 's' : ''}`}
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                )} */}
                            {/* </> */}
                        {/* )} */}
                        <Grid item xs={12} sm={3}>
                            <TextField
                                label='From Date'
                                type='date'
                                variant='outlined'
                                value={storeDateFilter.startDate}
                                onChange={(e) => setStoreDateFilter({ ...storeDateFilter, startDate: e.target.value })}
                                InputLabelProps={{ shrink: true }}
                                fullWidth

                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                label='End Date'
                                type='date'
                                variant='outlined'
                                value={storeDateFilter.endDate}
                                onChange={(e) => setStoreDateFilter({ ...storeDateFilter, endDate: e.target.value })}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                            />
                        </Grid>

                        {(() => {
                        const isDGMOrAdmin = userRoleNames.includes('DGM Ops') || userRoleNames.includes('DGM Design') || userRoleNames.includes('AGM Design') || isAdmin;
                        if (!isDGMOrAdmin) return null;
                        
                        return (
                            <>
                                {/* Horizontal Line */}
                                <Grid item xs={12}>
                                    <hr style={{ margin: '16px 0', border: '1px solid #e0e0e0' }} />
                                </Grid>
                                
                                {/* Select Role Dropdown */}
                                <Grid item xs={12} sm={3}>
                                    <FormControl fullWidth>
                                        <TextField
                                            select
                                            label="Select Role"
                                            variant="outlined"
                                            value={roleWiseFilter}
                                            onChange={(e) => {
                                                setRoleWiseFilter(e.target.value);
                                                setSelectedRoleWiseUser([]);
                                            }}
                                            fullWidth
                                        >
                                            <MenuItem value="">None</MenuItem>
                                            <MenuItem value="AGM">AGM</MenuItem>
                                            <MenuItem value="ODM">ODM</MenuItem>
                                            <MenuItem value="Designer">Designer</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                
                                {/* Dynamic User Filter based on selected role */}
                                {roleWiseFilter && roleWiseUsers.length > 0 && (
                                    <Grid item xs={12} sm={3}>
                                        <FormControl fullWidth>
                                            <Autocomplete
                                                multiple
                                                value={selectedRoleWiseUser}
                                                options={roleWiseUsers}
                                                getOptionLabel={(option) => option.name}
                                                onChange={(e, val) => {
                                                    setSelectedRoleWiseUser(val);
                                                    // Set these users to main selectedUser filter
                                                    setSelectedUser(val);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label={`Select ${roleWiseFilter}${roleWiseFilter === 'Designer' ? 's' : 's'}`}
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                )}
                            </>
                        );
                    })()}
                        <div style={{
                            display: "flex",
                            gap: "1rem",
                            marginTop: "10px",
                            paddingLeft: "16px"

                        }}>
                            <Button
                                variant='contained'
                                color='primary'
                                size='medium'
                                style={{
                                    backgroundColor: "#4caf50",
                                    color: "#fff",
                                    padding: "6px 20px",
                                    whiteSpace: "nowrap",
                                    // backgroundColor: isSubmitDisabled ? "#cccccc" : "#4caf50",
                                    // opacity: isSubmitDisabled ? 0.5 : 1,
                                }}
                                onClick={() => handleSubmitAllFilters()}
                            //   disabled={isSubmitDisabled}
                            >
                                Submit
                            </Button>

                            <Button
                                variant='contained'
                                color='secondary'
                                size='medium'
                                style={{
                                    backgroundColor: "#f44336",
                                    color: "#fff",
                                    padding: "6px 20px",
                                    whiteSpace: "nowrap",
                                }}
                                onClick={handleClearAllFilters}
                            >
                                Clear Filter
                            </Button>
                        </div>
                    </Grid>
                    

                    {/* === Search Type + Input + Submit & Clear === */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "1rem",
                            marginTop: "20px",
                        }}>
                        {/* <TextField
                            select
                            label="Search Type"
                            value={selectedSearchType}
                            onChange={(e) => setSelectedSearchType(e.target.value)}
                            variant="outlined"
                            style={{ width: "20%" }}
                            size="small"
                            SelectProps={{
                                renderValue: (selected) => {
                                const selectedItem = searchTypes.find(i => i.value === selected);
                                if (!selectedItem) return "None";

                                return (
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <span style={{ fontSize: "18px", color: selectedItem.color, display: "flex" }}>
                                        {selectedItem.icon}
                                    </span>
                                    <span>{selectedItem.label}</span>
                                    </div>
                                );
                                }
                            }}
                            >
                            <MenuItem value="" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                None
                            </MenuItem>

                            {searchTypes.map((item, index) => (
                                <MenuItem
                                key={index}
                                value={item.value}
                                style={{ display: "flex", alignItems: "center", gap: "10px" }}
                                >
                                <span
                                    style={{
                                    fontSize: "18px",
                                    color: item.color,
                                    display: "flex",        
                                    alignItems: "center",
                                    }}
                                >
                                    {item.icon}
                                </span>
                                <span>{item.label}</span>
                                </MenuItem>
                            ))}
                        </TextField> */}

                        {/* <TextField
                            label='Enter the input'
                            size='small'
                              value={searchInput}
                              onChange={(e) => setSearchInput(e.target.value)}
                            variant='outlined'
                            style={{ flexGrow: 1, minWidth: "300px" }}
                        /> */}


                    </div>
                </Paper>
                        )}

            </div>

            <br />
            {/* All Filter End Here */}

            {/* Table will be start here */}
            <br />
            <div>
                {rewardsData && <ERPSDashBoard
                    rewardsData={filteredRewardsData}
                    loading={loading}
                    viewType={viewType}
                    showToggle={showToggle}
                    viewMode={viewMode}
                    myRewardsDateFilter={myRewardsDateFilter}
                    setMyRewardsDateFilter={setMyRewardsDateFilter}
                    handleMyRewardsDateSubmit={handleMyRewardsDateSubmit}
                    onViewModeChange={(mode) => {
                        setViewMode(mode);
                        setSelectedUser([]);
                        setSelectedExperienceCenter([]);
                        setSelectedLocation([]);
                        handleSubmitAllFilters(mode);
                    }} />}
            </div>
            <br />
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(ERPSFilter);
